// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__8o2Jv","col":"styles_col__WFWHA"};